<template>
  <!-- <div class="hero">
        <div class="content justify-content-center align-self-center">
          <h2 class="txt-in">
            <strong class="txt-built">{{ banner.title }}</strong><br />
            in <strong class="txt-intelligo">Intelligo.id</strong>
          </h2>
          <p class="txt-blr" v-html="banner.description"></p>
          <router-link to="/login">
            <button class="btn-daftar">Join Now</button>
          </router-link>
        </div>
        <div class="right-girl col">
          <img id="imgHero" src="../assets/imgHero.png">
        </div>
  </div> -->
  <div
    class="row hero m-0 w-100 d-flex justify-content-evenly justify-conten-around align-items-center"
  >
    <div class="col-md-5 text-center mt-5 mt-xl-0 heroComp">
      <h2 class="txt-in mb-3 mb-xl-0">
        <strong class="txt-built">Built your Skill</strong><br />
        in <strong class="txt-intelligo">Intelligo.id</strong>
      </h2>
      <p class="txt-blr mb-3 mb-xl-0">
        Belajar skill Web Development & Data Science dengan Learning and
        Assistant
      </p>
      <router-link to="/login">
        <button @click="JoinNowClick" class="btn-daftar">Join Now</button>
      </router-link>
    </div>
    <div
      class="col-md-5 d-flex justify-content-center align-items-center d-xl-block"
    >
      <img id="imgHero" src="../assets/imgHero.png" />
    </div>
  </div>
</template>

<script>
export default {
  name: `HeroComp`,
  props: ["banner"],
};
</script>

<style>
#app {
  font-family: "Poppins", sans-serif;
}
.hero {
  height: 80vh;
}
.content {
  position: absolute;
}
.right-girl {
  margin-top: 100px;
  margin-left: 50%;
}
.btn-daftar {
  margin-top: 40px;
  margin-left: 100px;
  width: 180px;
  height: 45px;
  border-radius: 100px;
  background: #023047;
  border-radius: #023047;
  font-size: 16px;
  color: #fff;
}
.btn-daftar:hover {
  background-color: #fff;
  color: #023047;
}
.txt-built {
  font-size: 46px;
  font-weight: 700;
  color: #13214a;
}
.txt-in {
  margin-top: 20px;
  margin-left: 100px;
  font-size: 46px;
  font-weight: 700;
  color: #13214a;
}
.txt-intelligo {
  font-size: 46px;
  font-weight: 700;
  color: #f74d00;
}
.txt-blr {
  width: 400px;
  margin-top: 20px;
  margin-left: 100px;
  font-weight: 400;
  font-size: 16px;
  color: #78839e;
  margin-top: 20px;
}
#imgHero {
  /* margin-top: -10%; */
  width: 571px;
  height: 500px;
}

@media only screen and (max-width: 1100px) {
  #imgHero {
    width: 514px;
    height: 450px;
  }
}

@media only screen and (max-width: 1000px) {
  .txt-intelligo,
  .txt-built,
  .txt-in {
    font-size: 36px;
  }
  .txt-blr {
    width: 300px;
    font-size: 14px;
  }
  #imgHero {
    width: 457px;
    height: 400px;
  }
}

@media only screen and (max-width: 820px) {
  .txt-intelligo,
  .txt-built,
  .txt-in {
    font-size: 28px;
  }
  .txt-blr {
    width: 240px;
    font-size: 14px;
  }
  .btn-daftar {
    margin-top: 20px;
    margin-left: 100px;
    width: 140px;
    height: 45px;
  }
  /* #imgHero {
    width: 399px;
    height: 350px;
  } */
  .right-girl {
    margin-left: 45%;
  }
}

@media only screen and (max-width: 768px) {
  #imgHero {
    width: 100%;
    height: auto;
  }
  .hero {
    height: 800px;
  }
  .content {
    margin-top: 300px;
  }
  .txt-intelligo,
  .txt-built,
  .txt-in {
    width: 100%;
    margin-left: 0;
  }
  .txt-blr {
    width: 300px;
    font-size: 14px;
    margin-left: 0;
  }

  .btn-daftar {
    margin-left: 0;
  }
  .right-girl {
    margin-left: 10%;
  }
  #imgHero {
    margin-top: 0%;
  }
}

@media only screen and (max-width: 640px) {
  .heroComp {
    margin-top: 7rem !important;
  }

  #imgHero {
    width: 70% !important;
    height: 100% !important;
  }

  .txt-in,
  .txt-blr {
    width: 100% !important;
    margin: 0 !important;
    text-align: center;
  }

  .btn-daftar {
    margin: 0 auto !important;
    text-align: center;
  }

  #imgHero {
    width: 100%;
    height: auto;
  }
}

@media only screen and (max-width: 320px) {
  #imgHero {
    width: 100% !important;
    height: max-content !important;
  }

  .txt-blr {
    width: 250px;
  }

  .txt-blr,
  .txt-in,
  .btn-daftar {
    margin-left: 0;
  }
}
</style>
